import { Component, EventEmitter, Input, Output } from '@angular/core';
import { FormGroup, FormBuilder, FormControl } from '@angular/forms';
import { MatSelectModule } from '@angular/material/select';
import { ProjectConfiguration } from '@models/ProjectConfiguration';

@Component({
  selector: 'app-publication-configuration-selector',
  imports: [MatSelectModule],
  templateUrl: './publication-configuration-selector.component.html',
  styleUrl: './publication-configuration-selector.component.scss'
})
export class PublicationConfigurationSelectorComponent {
  @Input() project!: ProjectConfiguration;
  @Output() configurationSelected = new EventEmitter<string>();
  form: FormGroup;

  constructor(private formBuilder: FormBuilder) {
    this.form = this.formBuilder.group({
      configuration: new FormControl(ProjectConfiguration.Default),
    });
  }

  onPublicationConfigurationChange(selectedValue: string) {
    this.configurationSelected.emit(selectedValue);
  }
}
